import React from 'react';
import { Link, useLocation } from 'react-router-dom';

// Import images
import footerLogo from '../../../assets/images/resources/logo-1.png';
import footerLogo2 from '../../../assets/images/resources/logo2.png';

const FooterTwo = () => {
    const location = useLocation();

    // Home page check
    const isHomePage =
        location.pathname === '/home' || location.pathname === '/';

    // Contact page check
    const isContactPage =
        location.pathname === '/contact' ||
        location.pathname === '/contact-us' ||
        location.pathname.includes('contact');

    // Dynamic logo
    const currentLogo = isContactPage ? footerLogo : footerLogo2;

    // Dynamic CSS with !important for home page
    const footerStyles = `
        .site-footer-two .footer-branches {
            display: flex;
            flex-direction: column;
            align-items: stretch;
            gap: 12px;
            width: 100%;
            margin-top: 6px;
        }

        .site-footer-two .footer-branch {
            width: 100%;
            border: 1px solid rgba(178, 13, 93, 0.28);
            border-radius: 12px;
            padding: 12px 14px 10px;
        }

        .site-footer-two .footer-branch__label {
            display: inline-block;
            margin-bottom: 6px;
            font-size: 11px;
            font-weight: 700;
            letter-spacing: 0.14em;
            text-transform: uppercase;
            background: linear-gradient(90deg, #B20D5D 0%, #4A0AB4 100%);
            -webkit-background-clip: text;
            background-clip: text;
            -webkit-text-fill-color: transparent;
        }

        .site-footer-two .footer-branch p {
            margin: 0;
            font-size: 14px;
            line-height: 1.55;
            color: rgba(255, 255, 255, 0.9);
        }

        .site-footer-two .footer-branch__address + .footer-branch__address {
            margin-top: 12px;
            padding-top: 12px;
            border-top: 1px solid rgba(178, 13, 93, 0.45);
        }

        .site-footer-two .footer-branch__phones {
            margin-top: 8px !important;
        }

        .site-footer-two .footer-branch__phones a {
            display: inline-block;
            margin-right: 12px;
            color: rgba(255, 255, 255, 0.9);
            white-space: nowrap;
        }

        ${isHomePage ? `
            .site-footer-two {
                color: black !important;
                background-color: #f8f8f8 !important;
            }

            .site-footer-two h3 {
                color: black !important;
            }

            .site-footer-two a {
                color: black !important;
            }

            .site-footer-two li {
                color: black !important;
            }

            .footer-widget__title {
                color: black !important;
            }

            .footer-widget-two__about-text {
                color: black !important;
            }

            .footer-widget-two__newsletter-text {
                color: black !important;
            }

            .address_t p {
                color: black !important;
            }

            .site-footer-two .footer-branch {
                border-color: rgba(178, 13, 93, 0.2);
                background: #fff;
            }

            .site-footer-two .footer-branch p,
            .site-footer-two .footer-branch__phones a {
                color: #1a1a1a !important;
            }

            .site-footer-two__top-content {
                background-color: white !important;
                box-shadow: 0 4px 15px rgba(0,0,0,0.1) !important;
                color: black !important;
            }

            .site-footer-two__top-content span,
            .site-footer-two__top-content i {
                color: #c622a8 !important;
            }

            .site-footer-two__social a,
            .site-footer-two__social i {
                color: white !important;
            }

            .site-footer-two__bottom-text,
            .site-footer-two__bottom-menu,
            .site-footer-two__bottom-menu li,
            .site-footer-two__bottom-menu a {
                color: white !important;
            }
        ` : ''}
    `;

    const contactDetails = {
        email: [
            "sheldon@gtnomads.com",
            "andre@gtnomads.com"
        ],
        branches: [
            {
                label: "UAE BRANCH",
                addresses: [
                    [
                        "Globetrotting Nomads FZC LLC",
                        "CWS-1V-001696",
                        "26th Floor, Amber Gem Tower, Ajman"
                    ]
                ],
                phones: [
                    { display: "+971 56 987 0856", tel: "+971569870856" }
                ]
            },
            {
                label: "INDIA BRANCH",
                addresses: [
                    ["O-303, Roshina Enclave, Margao, Goa. 403601"],
                    ["304, City Center, Patto, Panjim, Goa. 403001"]
                ],
                phones: [
                    { display: "+91 98229 80756", tel: "+919822980756" },
                    { display: "+91 98229 59761", tel: "+919822959761" }
                ]
            }
        ]
    };

    return (
        <>
            <style>{footerStyles}</style>

            <footer className="site-footer-two">
                <div className="site-footer-two__top">
                    <div className="container">
                        <div className="site-footer-two__top-inner">
                            <Link to="/#events" className="site-footer-two__top-content">
                                Explore <span>Events</span>
                                <i className="icon-arrow-up"></i>
                            </Link>
                        </div>
                    </div>
                </div>

                <div className="site-footer-two__middle">
                    <div className="container">
                        <div className="site-footer-two__middle-inner">
                            <div className="row">

                                {/* About */}
                                <div
                                    className="col-xl-4 col-lg-6 col-md-6 wow fadeInUp"
                                    data-wow-delay="100ms"
                                >
                                    <div className="footer-widget__column footer-widget-two__about">
                                        <div className="site-footer-two__logo">
                                            <Link to="/">
                                                <img
                                                    src={currentLogo}
                                                    alt="GT Nomads"
                                                    style={{ width: "180px" }}
                                                />
                                            </Link>
                                        </div>

                                        <p className="footer-widget-two__about-text">
                                            Nomadic Event Pvt Ltd — curating bespoke journeys
                                            and world-class events since 2008 Registered in Goa,
                                            India with overseas offices in UAE.
                                        </p>

                                        <div className="site-footer-two__social">
                                            <Link to="#">
                                                <i className="icon-facebook"></i>
                                            </Link>

                                            <Link to="#">
                                                <i className="icon-fi"></i>
                                            </Link>

                                            <Link to="#">
                                                <i className="icon-instagram"></i>
                                            </Link>

                                            <Link to="#">
                                                <i className="icon-pinterest"></i>
                                            </Link>
                                        </div>
                                    </div>
                                </div>

                                {/* Contact */}
                                <div
                                    className="col-xl-4 col-lg-6 col-md-6 wow fadeInUp"
                                    data-wow-delay="300ms"
                                >
                                    <div className="footer-widget__column footer-widget__contact">
                                        <div className="footer-widget__title-box">
                                            <h3 className="footer-widget__title">
                                                Contact
                                            </h3>
                                        </div>

                                        <div className="footer-widget__contact-inner">
                                            <ul className="footer-widget__contact-list list-unstyled">

                                                <li>
                                                    <div className="icon">
                                                        <span className="icon-envelop"></span>
                                                    </div>

                                                    <div className="text">
                                                        {contactDetails.email.map((email, index) => (
                                                            <p key={index}>
                                                                <a href={`mailto:${email}`}>
                                                                    {email}
                                                                </a>
                                                            </p>
                                                        ))}
                                                    </div>
                                                </li>

                                                <li className="footer-branches">
                                                    {contactDetails.branches.map((branch) => (
                                                        <div className="footer-branch" key={branch.label}>
                                                            <span className="footer-branch__label">{branch.label}</span>
                                                            {branch.addresses.map((lines) => (
                                                                <p className="footer-branch__address" key={lines[0]}>
                                                                    {lines.map((line, index) => (
                                                                        <React.Fragment key={line}>
                                                                            {index > 0 && <br />}
                                                                            {line}
                                                                        </React.Fragment>
                                                                    ))}
                                                                </p>
                                                            ))}
                                                            <p className="footer-branch__phones">
                                                                {branch.phones.map((phone) => (
                                                                    <a key={phone.tel} href={`tel:${phone.tel}`}>
                                                                        {phone.display}
                                                                    </a>
                                                                ))}
                                                            </p>
                                                        </div>
                                                    ))}
                                                </li>

                                            </ul>
                                        </div>
                                    </div>
                                </div>

                                {/* Newsletter */}
                                <div
    className="col-xl-4 col-lg-6 col-md-6 wow fadeInUp"
    data-wow-delay="400ms"
>
    <div className="footer-widget__column footer-widget-two__newsletter">
        <div className="footer-widget__title-box">
            <h3 className="footer-widget__title">
                Why GTNomads?
            </h3>
        </div>

        <p className="footer-widget-two__newsletter-text">
            Delivering exceptional corporate events and
            unforgettable experiences worldwide.
        </p>

        <ul
            style={{
                listStyle: "none",
                padding: 0,
                marginTop: "20px",
            }}
        >
            <li style={{ marginBottom: "12px" }}>
                ✓ 500+ Events Successfully Delivered
            </li>
            <li style={{ marginBottom: "12px" }}>
                ✓ 50+ Global Destinations
            </li>
           
            <li style={{ marginBottom: "12px" }}>
                ✓ Dedicated Project Managers
            </li>
        </ul>

       
    </div>
</div>

                            </div>
                        </div>
                    </div>
                </div>

                <div className="site-footer-two__bottom">
                    <div className="container">
                        <div className="site-footer-two__bottom-inner">
                            <p className="site-footer-two__bottom-text">
                                Copyright © 2026 Gtnomads | Designed by Metabyte.
                            </p>

                            <ul className="list-unstyled site-footer-two__bottom-menu">
                                <li>
                                    <Link to="/">Terms & Conditions</Link>
                                </li>

                                <li>
                                    <Link to="/">Privacy Policy</Link>
                                </li>

                                <li>
                                    <Link to="/">Contact Us</Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    );
};

export default FooterTwo;